
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProgressStepper from "../visitConstant/ProgressSteppers/ProgressStepper";
import apiHelper from "../ApiHelpar/apiHelper";
import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";
import {
  AAD_HOSPITAL_BRANCH,
  GRT_HOSPITA_BY_NAME_ID,
} from "../visitConstant/ApiConstant";

const AddHospitalBranch = ({
  expandedView,
  dataEdit,
  hospitalId,
  BaranchId,
  Role,
  RefreshApi,
  setRefreshApi,
}) => {
  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({
    branchName: "",
    branchAddress: "",
    selectedHospital: {},
  });
  const [hospitalList, setHospitalList] = useState([]);
  const [hospitalSearch, setHospitalSearch] = useState("");

  // UI state
  const [status, setStatus] = useState({
    loading: false,
    error: "",
    success: "",
  });

  // Load existing data if in edit mode
  useEffect(() => {
    if (dataEdit?.branchName) {
      setFormData({
        branchName: dataEdit.branchName || "",
        branchAddress: dataEdit.branchAddress || "",
        selectedHospital: dataEdit.hospital || {},
      });
      setHospitalSearch(dataEdit.hospital?.name || "");
    }
  }, [dataEdit]);

  // Update hospital search when selected hospital changes
  useEffect(() => {
    if (formData.selectedHospital?.name) {
      setHospitalSearch(formData.selectedHospital.name);
    }
  }, [formData.selectedHospital]);

  // Fetch hospitals when search term changes
  useEffect(() => {
    if (hospitalSearch) {
      fetchHospitals();
    }
  }, [hospitalSearch]);

  const fetchHospitals = async () => {
    try {
      setStatus((prev) => ({ ...prev, loading: true, error: "" }));
      const response = await apiHelper(GRT_HOSPITA_BY_NAME_ID, {
        id: 0, //hospitalId,
        name: hospitalSearch,
        active: true,
      });

      if (response.respInfo.code === "0") {
        setHospitalList(response.respData.respMsg || []);
      } else {
        throw new Error(
          response.respInfo.message || "Failed to fetch hospitals"
        );
      }
    } catch (err) {
      console.error("Error fetching hospitals:", err);
      setStatus((prev) => ({ ...prev, error: "Failed to load hospitals" }));
    } finally {
      setStatus((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (status.error) {
      setStatus((prev) => ({ ...prev, error: "" }));
    }
  };

  const validateForm = () => {
    const { branchName, branchAddress, selectedHospital } = formData;

    if (!branchName.trim()) {
      setStatus((prev) => ({ ...prev, error: "Branch name is required" }));
      return false;
    }

    if (!branchAddress.trim()) {
      setStatus((prev) => ({ ...prev, error: "Branch address is required" }));
      return false;
    }

    if (!selectedHospital || !Object.keys(selectedHospital).length) {
      setStatus((prev) => ({ ...prev, error: "Please select a hospital" }));
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setStatus({ loading: true, error: "", success: "" });

    try {
      const data = {
        ...dataEdit,
        branchName: formData.branchName,
        branchAddress: formData.branchAddress,
        hospital: formData.selectedHospital,
        active: true,
      };

      const response = await apiHelper(AAD_HOSPITAL_BRANCH, data);

      console.log(response.respData.message);
      if (response.respInfo.code === "0") {
        // Success handling
        setStatus((prev) => ({
          ...prev,
          success: response.respData.message || "Branch added successfully",
        }));

        // Store data in session storage
        // sessionStorage.setItem(
        //   "branchData",
        //   JSON.stringify(response.respData.respMsg)
        // );

        // Reset form after successful submission

        setFormData({
          branchName: "",
          branchAddress: "",
          selectedHospital: {},
        });
        setHospitalSearch("");

       //api list refresh   
  setRefreshApi(!RefreshApi)

      } else {
        throw new Error(response.respInfo.message || "Failed to add branch");
      }
    } catch (err) {
      setStatus((prev) => ({
        ...prev,
        error: err.message || "Error adding branch. Please try again.",
      }));
      console.error("Branch submission error:", err);
    } finally {
      setStatus((prev) => ({ ...prev, loading: false }));
    }
  };

  // Destructure for cleaner JSX
  const { branchName, branchAddress, selectedHospital } = formData;
  const { loading, error, success } = status;

  return (
    <div className="justify-content-center w-100" style={{ maxWidth: 700 }}>
      <div className="card shadow-sm">
        <div className="card-header">
          <h4 className="mb-0">{dataEdit ? "Edit" : "Add"} Hospital Branch</h4>
        </div>
        <div className="card-body">
          {error && (
            <div className="alert alert-danger alert-dismissible fade show">
              {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => setStatus((prev) => ({ ...prev, error: "" }))}
              />
            </div>
          )}

          {success && (
            <div className="alert alert-success alert-dismissible fade show">
              {success}
              <button
                type="button"
                className="btn-close"
                onClick={() => setStatus((prev) => ({ ...prev, success: "" }))}
              />
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">Hospital*</label>
              <UserSearchDropdown
                options={hospitalList}
                handleInputChange={setHospitalSearch}
                onSelect={(hospital) =>
                  handleInputChange("selectedHospital", hospital)
                }
                value={selectedHospital}
                loading={loading}
                Placeholder="Enter Hospital Name"
                searchTerm={hospitalSearch}
                newEntry={true}
                UserSearchDrop={false}
                displayKey={(option) => option?.name || ""}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Branch Name*</label>
              <input
                type="text"
                className="form-control"
                value={branchName}
                onChange={(e) =>
                  handleInputChange("branchName", e.target.value)
                }
                placeholder="Enter branch name"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Branch Address*</label>
              <textarea
                className="form-control"
                value={branchAddress}
                onChange={(e) =>
                  handleInputChange("branchAddress", e.target.value)
                }
                placeholder="Enter branch address"
                required
                rows={4}
              />
            </div>

            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary text-light"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : dataEdit ? (
                  " Add Branch"
                ) : (
                  "Update Branch"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddHospitalBranch;